<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    filterable
                    placeholder="商家名称"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pgid"
                    filterable
                    placeholder="代采组"
                  >
                    <el-option
                      v-for="item in resData.options.pg"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pg_member_id"
                    filterable
                    placeholder="代采员"
                  >
                    <el-option
                      v-for="item in resData.options.pg_member"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>商家列表</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="showCreateDialog"
            >添加
          </el-button>
        </div>
        <div v-if="resData.list" style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="id"
              label="序号"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="supply_name"
              label="商家名称"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="admin_name"
              label="代采员"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="add_admin_name"
              label="添加人"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="create_time"
              label="添加时间"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="message"
              label="提示内容"
            ></el-table-column>
            <el-table-column
              align="center"
              shiw-overflow-tooltip
              width="150"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status != 2"
                  type="danger"
                  size="mini"
                  @click="removeTips(scope.row.id)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.p"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.total"
            :page-size="form.psize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="createInterceptPackageShow"
      width="30%"
      title="添加商家"
      :before-close="closeCreateDialog"
    >
      <el-form :model="checkForm">
        <el-form-item label="商家名字">
          <el-select
            v-model="checkForm.supply_id"
            filterable
            remote
            reserve-keyword
            placeholder="支持模糊搜索"
            :remote-method="selectSupply"
            :loading="selectSupplyloading"
          >
            <el-option
              v-for="item in supplyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提示内容">
          <el-input
            v-model="checkForm.message"
            placeholder="录入3个字以内"
          ></el-input>
        </el-form-item>
        <el-form-item label="批量导入">
          <el-upload
            ref="upload"
            :action="action"
            name="excel"
            :limit="1"
            :on-success="importFile"
            :file-list="fileList"
            :auto-upload="true"
            with-credentials
          >
            <el-button slot="trigger" size="mini" type="primary">
              选择文件</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCreateDialog">取 消</el-button>
        <el-button type="primary" @click="createSupplyTips">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HeaderTabs from "../wavepicking/components/HeaderTabs";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "SupplyPackageTips",
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      fileList: [],
      createInterceptPackageShow: false,
      loading: false,
      selectSupplyloading: false,
      supplyOptions: {},
      filterFold: false,
      tableLoading: false,
      checkForm: {
        supply_id: "",
        message: "",
      },
      form: {
        supply_name: "",
        pgid: "",
        pg_member_id: "",
        is_excel: 0,
        p: 1,
        psize: 50,
      },
      resData: {
        list: [],
        options: {
          status: [],
        },
      },
      action: `${apiBaseURL}/erp/SupplyPackageTips/importFile`,
    };
  },
  methods: {
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData() {
      this.$http
        .post("/erp/SupplyPackageTips/getList", this.form)
        .then((res) => {
          if (res.data.code == 200) {
            if (this.form.is_excel) {
              window.open(apiBaseURL + res.data.data.file);
            } else {
              this.resData = res.data.data;
            }
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    reset() {
      this.form = {
        supply_name: "",
        pgid: "",
        pg_member_id: "",
        is_excel: 0,
        p: 1,
        psize: 50,
      };
      this.fetchData();
    },
    search() {
      this.form.is_excel = 0;
      this.form.p = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.form.is_excel = 0;
      this.form.p = val;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.form.is_excel = 0;
      this.form.p = 1;
      this.form.psize = val;
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.fetchData();
    },
    importFile(res) {
      if (res.code == 200) {
        if (res.data.file) {
          window.open(apiBaseURL + res.data.file);
        }
        this.fetchData();
        this.closeCreateDialog();
        this.$message.success("导入成功");
      } else {
        this.$message.e(res.msg);
      }
    },
    showCreateDialog() {
      this.createInterceptPackageShow = true;
    },
    closeCreateDialog() {
      this.fileList = [];
      this.checkForm = {
        shipping_num: "",
      };
      this.createForm = {
        shipping_nums: [],
      };
      this.createInterceptPackageShow = false;
    },
    createSupplyTips() {
      this.$http
        .post("/erp/SupplyPackageTips/create", this.checkForm)
        .then((res) => {
          if (res.data.code == 200) {
            this.fetchData();
            this.closeCreateDialog();
            this.$message.success("添加成功");
          } else {
            this.$message.e(res.data.msg);
            this.$refs.shipping_num_input.focus();
          }
        });
    },
    removeTips(id) {
      this.$http
        .post("/erp/SupplyPackageTips/delete", {
          id,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("删除成功");
            this.fetchData();
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    checkShippingNum() {
      this.$http
        .post("/erp/AsPackageIntercept/createCheck", {
          shipping_num: this.checkForm.shipping_num,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.createForm.shipping_nums.push(res.data.data.shipping_num);
            this.checkForm.shipping_num = "";
            this.$refs.shipping_num_input.focus();
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    deleteShippingNum(tag) {
      this.createForm.shipping_nums.splice(
        this.createForm.shipping_nums.indexOf(tag),
        1
      );
    },
    selectSupply(val) {
      this.selectSupplyloading = true;
      this.$http
        .post("/erp/Common/fetchSupplyBySearch", {
          supply_name: val,
        })
        .then((res) => {
          this.selectSupplyloading = false;
          if (res.data.code == 200) {
            this.supplyOptions = res.data.data;
          }
        });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/setting/SupplyPackageTips.vue